import React from "react";
var __jsx = React.createElement;
var OilBanner = function OilBanner(_ref) {
  var section = _ref.section;
  var content = section.content;
  var inner = /*#__PURE__*/React.createElement("div", {
    className: "relative w-full overflow-hidden rounded-lg md:rounded-none"
  }, /*#__PURE__*/React.createElement("img", {
    src: content.image_mobile,
    alt: "syarah oil banner",
    loading: "eager",
    className: "block md:hidden w-full h-[180px] object-cover"
  }), /*#__PURE__*/React.createElement("img", {
    loading: "eager",
    src: content.image,
    alt: "syarah oil banner",
    className: "hidden md:block h-full w-full"
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 flex flex-col justify-center items-start ps-4 md:ps-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start text-start gap-2.5 md:gap-7 w-[210px] md:w-[734px] max-w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start gap-1 md:gap-4 w-full"
  }, content.title && /*#__PURE__*/React.createElement("h1", {
    className: "text-white font-bold text-[18px] leading-[28px] md:text-[36px] md:leading-[40px] md:tracking-[-0.9px] m-0"
  }, content.title), content.subtitle && /*#__PURE__*/React.createElement("p", {
    className: "text-white font-normal text-[16px] leading-[24px] tracking-[-0.4px] md:text-[24px] md:leading-[32px] md:tracking-[-0.6px] m-0"
  }, content.subtitle)), content.subtitle_2 && /*#__PURE__*/React.createElement("p", {
    className: "text-white font-medium text-[14px] leading-[24px] tracking-[-0.35px] pe-10 md:pe-0 md:text-[20px] md:leading-[28px] md:font-semibold md:tracking-[-0.5px] m-0"
  }, content.subtitle_2))));
  return /*#__PURE__*/React.createElement("div", {
    className: "block max-w-[1200px] mx-auto px-4 mb-6 md:px-0 md:mb-8 md:mt-4"
  }, inner);
};
export default OilBanner;